import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { BASE_SEO_DATA, easihubApiInterceptor, provideLayeredStyles, type BaseSEOData } from '@easihub/ngx';
import { AUTH_ACTIONS } from '../auth/auth-actions';
import { appRoutes } from './app.routes';
import { provideClientConfig } from './client.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientConfig(),

    provideBrowserGlobalErrorListeners(),
    provideClientHydration(withEventReplay()),

    provideLayeredStyles(),

    {
      provide: BASE_SEO_DATA,
      useValue: {
        title: 'EasiHub',
        description: ''
      } satisfies BaseSEOData
    },

    provideHttpClient(
      withInterceptors([
        easihubApiInterceptor
      ])
    ),

    //   customizeProvidedViewportScroller(),
    //   provideAppInitializer(() => {
    //     const vs = inject(ViewportScroller);
    //     vs.setOffset([0, 120]);
    //   }),

    provideRouter(appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),

    AUTH_ACTIONS
  ],
};
